import React from 'react';

import { IconButton } from '@atlaskit/button/new';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import type { ThemeAppearance } from '@atlaskit/lozenge';
import Lozenge from '@atlaskit/lozenge';

import {
  DescriptionTextStyled,
  OnboardingDescriptionStyled,
  OnboardingIconWrapper,
  OnboardingPanelStyled,
  OnboardingTitleStyled,
  onboardingPanelColors,
} from './OnboardingPanel.styled';

export type OnboardingPanelProps = Readonly<{
  title: string;
  description: string;
  appearance: 'purple' | 'gray';
  icon: React.ElementType;
  iconLabel: string;
  redirectUrl: string;
}>;

export default function OnboardingPanel({
  title,
  description,
  appearance,
  icon,
  iconLabel,
  redirectUrl,
}: OnboardingPanelProps): JSX.Element {
  const IconComponent = icon;

  const handleRedirectClick = () => {
    window.open(redirectUrl, '_blank');
  };

  return (
    <OnboardingPanelStyled>
      <OnboardingTitleStyled
        backgroundColor={onboardingPanelColors[appearance].upperBackgroundToken}
        borderColor={onboardingPanelColors[appearance].border}
        opacity='0.5'
      >
        <OnboardingIconWrapper
          backgroundColor={
            onboardingPanelColors[appearance].icon.backgroundToken
          }
        >
          <IconComponent
            label={iconLabel}
            primaryColor={onboardingPanelColors[appearance].icon.primaryToken}
            secondaryColor={
              onboardingPanelColors[appearance].icon.backgroundToken
            }
          />
        </OnboardingIconWrapper>
        <Lozenge
          appearance={
            onboardingPanelColors[appearance].lozenge as ThemeAppearance
          }
        >
          {title}
        </Lozenge>
      </OnboardingTitleStyled>
      <OnboardingDescriptionStyled
        backgroundColor={onboardingPanelColors[appearance].lowerBackgroundToken}
        borderColor={onboardingPanelColors[appearance].border}
        onClick={handleRedirectClick}
      >
        <DescriptionTextStyled color={onboardingPanelColors[appearance].text}>
          {description}
        </DescriptionTextStyled>
        <IconButton
          icon={(props) => (
            <ShortcutIcon
              {...props}
              primaryColor={onboardingPanelColors[appearance].icon.primaryToken}
              secondaryColor={
                onboardingPanelColors[appearance].icon.backgroundToken
              }
            />
          )}
          label='onboarding-panel-more-button'
          appearance='subtle'
        />
      </OnboardingDescriptionStyled>
    </OnboardingPanelStyled>
  );
}
